import React from "react";
// import GraphTemplate from "../Graphs/GraphTemplate";
import GraphTemplateEPROsA from "../../Graphs/GraphTemplateEPROsA";
import AnotherReportsListSidebar from "./AnotherReportsListSidebar";

import AdminNavbar from "../../AdminNavbar";
import { Col, Container, Row } from "react-bootstrap";

const A004WIgraphs = () => {
  return (
    <>
      <AdminNavbar />
      <AnotherReportsListSidebar/>
      <Container fluid={true} >
      {/* style={{align:'left'}} */}
        <div className="mt-4">
        <div className="article">
        <h4>Weekly Intensity & Interference</h4>
        <p></p> 
        <p></p> 
        <p></p> 
        <p className="TitleDB">Weekly Pain Intensity</p>
          <Row>
            <Col xs={10}>
              <GraphTemplateEPROsA report={"ACT_weekly_pain_intensity004A"} />
            </Col>
          </Row>
          <Row>
            <Col xs={10}>
              <GraphTemplateEPROsA report={"ST_weekly_pain_intensity004A"} />
            </Col>
          </Row>
        <p></p> 
        <p className="TitleDB">Weekly Pain Interference</p>
          <Row>
            <Col xs={10}>
              <GraphTemplateEPROsA report={"ACT_weekly_pain_interference004A"} />
            </Col>
          </Row>
          <Row>
            <Col xs={10}>
              <GraphTemplateEPROsA report={"ST_weekly_pain_interference004A"} />
            </Col>
          </Row>
          <p></p> 
        <p className="TitleDB">Weekly Sleep Interference</p>
          <Row>
            <Col xs={10}>
              <GraphTemplateEPROsA report={"ACT_weekly_sleep_interference004A"} />
            </Col>
          </Row>
          <Row>
            <Col xs={10}>
              <GraphTemplateEPROsA report={"ST_weekly_sleep_interference004A"} />
            </Col>
          </Row>
          </div>
        </div>
      </Container>
    </>
  );
};

export default A004WIgraphs;
{/* <AdminNavbar/>
<Jumbotron>
    <Container fluid={true}>
        <Row>
            <Col>
                <h1>004 Participants</h1>
            </Col>
        </Row>
    </Container>
</Jumbotron>
<AnotherReportsListSidebar/> */}